import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faArrowsAltH } from "@fortawesome/pro-solid-svg-icons/faArrowsAltH";
import { faLongArrowAltLeft } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltLeft";
import { faLongArrowAltRight } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltRight";

import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import IntegrationSyncDirection from "@mapmycustomers/shared/enum/integrations/IntegrationSyncDirection";

import {
  dynamicsRound,
  dynamicsSmallLogo,
  hubspotLogoRound,
  hubspotSmallLogo,
  salesforceLogoRound,
  salesforceSmallLogo,
  zohoLogoRound,
  zohoSmallLogo,
} from "@app/scene/settings/component/Integrations/logo";

const integrationIcon: Record<IntegrationService, string> = {
  [IntegrationService.DYNAMICS]: dynamicsSmallLogo,
  [IntegrationService.HUBSPOT]: hubspotSmallLogo,
  [IntegrationService.SALESFORCE]: salesforceSmallLogo,
  [IntegrationService.ZOHO]: zohoSmallLogo,
};

const integrationIconRound: Record<IntegrationService, string> = {
  [IntegrationService.DYNAMICS]: dynamicsRound,
  [IntegrationService.HUBSPOT]: hubspotLogoRound,
  [IntegrationService.SALESFORCE]: salesforceLogoRound,
  [IntegrationService.ZOHO]: zohoLogoRound,
};

const integrationDirectionMap: Record<IntegrationSyncDirection, IconDefinition> = {
  [IntegrationSyncDirection.BOTH_DIRECTIONS]: faArrowsAltH,
  [IntegrationSyncDirection.MMC_TO_SERVICE]: faLongArrowAltLeft,
  [IntegrationSyncDirection.SERVICE_TO_MMC]: faLongArrowAltRight,
};

export const getIntegrationIcon = (service: IntegrationService, round: boolean = false): string =>
  round ? integrationIconRound[service] : integrationIcon[service];

export const getIntegrationDirectionIcon = (direction: IntegrationSyncDirection) =>
  integrationDirectionMap[direction];
